import { Injectable, Inject} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject} from 'rxjs/Subject';
import { Http, Response} from '@angular/http';
import { ISlider, IResult } from './slider.model';


// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Service class for slider (obsolete)
 **/
@Injectable()

export class SliderService{

}



// WEBPACK FOOTER //
// ./src/app/slider/slider.service.ts